import React from "react";
import { IconButton, MenuItem, TextField } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import ClearIcon from "@material-ui/icons/Clear";
import MuiTableHead from "@material-ui/core/TableHead";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import CustomDatePickerRange from "../../../app/components/custom.date.picker.range";
import {
  HEAD_CELLS,
  HEAD_CELLS_NOT_INCLUDED,
  OPPORTUNITY_STAGE_OPTIONS,
  TAB_VALUE,
} from "../../constants";

// create a styled table cell with no horizontal padding
const StyledTableCell = withStyles((theme) => ({
  root: {
    padding: "5px",

    "&:first-child": {
      paddingLeft: "10px",
    },
  },
}))(TableCell);

const TableSidesNotIncludedFilterHead = ({
  filters,
  setFilters,
  orderBy,
  order,
  tabValue,
}) => {
  const classes = useStyles();

  const updateFilters = (id, value, type, startEnd) => {
    if ([type === "y_n" || type === "select"] && value === "all") {
      const filtersCopy = { ...filters };
      delete filtersCopy[id];
      return setFilters(filtersCopy);
    }

    if (type === "date") {
      let prevValue = filters[id] || {
        id: id,
        type: "date",
      };
      if (startEnd === "start") {
        prevValue = {
          ...prevValue,
          start: value,
        };
      } else if (startEnd === "end") {
        prevValue = {
          ...prevValue,
          end: value,
        };
      }
      return setFilters({
        ...filters,
        [id]: prevValue,
      });
    }

    setFilters({
      ...filters,
      [id]: {
        ...filters[id],
        value: value,
        type: type,
      },
    });
  };

  const renderInputField = (id, type) => {
    if (type === "text")
      return (
        <TextField
          value={filters[id]?.value || ""}
          onChange={(e) => updateFilters(id, e.target.value, type)}
          size="small"
          variant="outlined"
          InputLabelProps={{ classes: classes }}
          fullWidth
        />
      );

    if (type === "select") {
      return (
        <TextField
          select
          size="small"
          id={`${id}-select`}
          value={filters[id]?.value ?? "all"}
          onChange={(e) => updateFilters(id, e.target.value, type)}
          variant="outlined"
          fullWidth
        >
          <MenuItem
            key="all"
            value="all"
          >
            All
          </MenuItem>
          {OPPORTUNITY_STAGE_OPTIONS.map((option) => (
            <MenuItem
              key={option}
              value={option}
            >
              {option}
            </MenuItem>
          ))}
        </TextField>
      );
    }
    if (type === "date")
      return (
        <CustomDatePickerRange
          selected={filters[id]?.start}
          onChange={(dates) => {
            const [start, end] = dates;
            const startDate = start ? new Date(start) : null;
            const endDate = end ? new Date(end) : null;
            if (startDate && !isNaN(startDate.getTime())) {
              updateFilters(id, startDate.getTime(), type, "start");
            }

            if (endDate && !isNaN(endDate.getTime())) {
              updateFilters(id, endDate.getTime(), type, "end");
            }
          }}
          startDate={filters[id]?.start ? new Date(filters[id]?.start) : null}
          endDate={filters[id]?.end ? new Date(filters[id]?.end) : null}
          selectsRange
          showYearDropdown
          showMonthDropdown
          useShortMonthInDropdown
          dateFormat={"dd/MMM/yyyy"}
          small={true}
          value={
            filters[id]?.start && filters[id]?.end
              ? [new Date(filters[id]?.start), new Date(filters[id]?.end)]
              : [null, null]
          }
        />
      );
  };

  const hasActiveFilters = Object.keys(filters).some(key => {
    const filter = filters[key];
    if (filter.type === 'date') {
      return filter.start || filter.end;
    }
    return filter.value;
  });

  const headers = (tabValue === TAB_VALUE.SITES_NOT_INCLUDED) ?
    HEAD_CELLS_NOT_INCLUDED : HEAD_CELLS;

  return (
    <MuiTableHead classes={classes}>
      <TableRow classes={classes}>
        <StyledTableCell>
          {hasActiveFilters && (
            <IconButton
              onClick={() => setFilters({})}
              size="small"
              style={{ 
                pointerEvents: 'auto',
                cursor: 'pointer',
                zIndex: 1000
              }}
            >
              <ClearIcon />
            </IconButton>
          )}
        </StyledTableCell>
        {headers.map(({ id, type }) => (
          <StyledTableCell
            style={
              ["enrollmentPlanLastUpdate", "soeLastUpdate"].includes(id)
                ? { minWidth: "10rem" }
                : {}
            }
            key={id}
            align="left"
            padding="default"
            sortDirection={orderBy === id ? order : false}
          >
            {renderInputField(id, type)}
          </StyledTableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};

export default TableSidesNotIncludedFilterHead;

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "var(--surface-50)",
    borderRadius: "10px",
  },
}));
